import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS, INLINES} from '@contentful/rich-text-types'
import {InlineLink, LogoSuite, Text} from '@primer/react-brand'

import type {PrimerComponentLogoSuite} from '../../../schemas/contentful/contentTypes/primerComponentLogoSuite'
import {Logo} from './Logo'

export type ContentfulLogoSuiteProps = {
  component: PrimerComponentLogoSuite
}

export function ContentfulLogoSuite({component}: ContentfulLogoSuiteProps) {
  const fields = component.fields
  const useMarquee = fields.marquee === 'slow' || fields.marquee === 'normal'
  const speed = fields.marquee === 'slow' || fields.marquee === 'normal' ? fields.marquee : 'normal'

  return (
    <LogoSuite align={fields.align || 'center'} hasDivider={fields.hasDivider}>
      <LogoSuite.Heading visuallyHidden={Boolean(fields.visuallyHideHeading)}>{fields.heading}</LogoSuite.Heading>
      {component.fields.description ? (
        <LogoSuite.Description>
          {documentToReactComponents(component.fields.description, {
            renderNode: {
              [BLOCKS.PARAGRAPH]: (_, children) => <Text as="p">{children}</Text>,
              [INLINES.HYPERLINK]: (node, children) => <InlineLink href={node.data.uri}>{children}</InlineLink>,
            },
          })}
        </LogoSuite.Description>
      ) : null}
      <LogoSuite.Logobar variant={fields.variant || 'emphasis'} marqueeSpeed={speed} marquee={useMarquee}>
        {fields.logos.map(logo => (
          <Logo key={logo} name={logo} />
        ))}
      </LogoSuite.Logobar>
    </LogoSuite>
  )
}

try{ ContentfulLogoSuite.displayName ||= 'ContentfulLogoSuite' } catch {}